export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11013.15ed8a84.jpg";